import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import { type Decoration } from '@api';
import { useEditorStore } from './EditorStore';
import { CheckboxCheckedIcon } from '@ui/icons';
import { TinPreview } from '@core/features/artworks';

type Props = {
  decoration: Decoration;
  onClose?: (confirmClose?: boolean) => void;
};

export const DecorationListItem: FC<Props> = ({ decoration }) => {
  const { title, text } = decoration;

  const {
    setDecoration,
    decoration: currentDecoration,
    tempImage,
  } = useEditorStore();
  const selected =
    decoration.id &&
    currentDecoration &&
    currentDecoration.id === decoration.id;

  return (
    <Box
      onClick={() => {
        if (currentDecoration && currentDecoration.id === decoration.id) {
          setDecoration(undefined);
        } else {
          setDecoration(decoration);
        }
        // if (onClose) {
        //   onClose();
        // }
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 4,
        padding: 2,
        backgroundColor: '#ECF1FC',
        border: selected ? '1px solid #0032A0' : '1px solid transparent',
      }}
    >
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: 50,
          border: selected ? 'none' : '2px solid #0032A0',
        }}
      >
        {selected && <CheckboxCheckedIcon />}
      </Box>

      {tempImage && (
        <TinPreview
          size="large"
          image={URL.createObjectURL(tempImage) ?? ''}
          decoration={decoration}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{ fontSize: 18, fontWeight: 600, textTransform: 'uppercase' }}
        >
          {title ? title : text}
        </Typography>
      </Box>
    </Box>
  );
};
